module.exports = __webpack_public_path__ + "static/media/Das_Korps_an_der_Suenger_Kirche.93c77714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_bei_den_Umzuegen/Das_Korps_an_der_Suenger_Kirche.jpg
// module id = 428
// module chunks = 0